import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './OperatingRatiosByLOBRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';
import { INDUSTRY_MEAN_LABEL } from '../../model/ColumnLabels';

interface OperatingRatiosByLOBHeaderProps {
  readonly helmet: HeaderHelmetProps;
}

export default function OperatingRatiosByLOBHeader({ helmet }: OperatingRatiosByLOBHeaderProps) {
  const { showBenchmark, showIndustryMean } = useContext(AppContext);

  return (
    <>
      <div
        className={`${styles.container} ${styles.OR_BY_LOB} ${
          showBenchmark ? '' : styles.collapse
        }`}
        data-testid="mix-of-business-row-header">
        <HeaderHelmet {...helmet} />
        <h5 className={`column_align_right ${styles.category_header_span3}`}>Medical Loss Ratio</h5>
        <h5 className={`column_align_right ${styles.category_header_span3}`}>Admin Expense Ratio</h5>
        <h5 className={`column_align_right ${styles.category_header_span3}`}>Combined Ratio</h5>
        <h5 className={`column_align_right ${styles.category_header_span2}`}>UW Gain(Loss)</h5>
      </div>
      <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
        <HeaderHelmet label="" />
        <h5 className="column_align_right">{showIndustryMean ? INDUSTRY_MEAN_LABEL : ''}</h5>
        <h5 className="column_align_right">CY</h5>
        <h5 className="column_align_right">PY</h5>
        <h5 className="column_align_right">{showIndustryMean ? INDUSTRY_MEAN_LABEL : ''}</h5>
        <h5 className="column_align_right">CY</h5>
        <h5 className="column_align_right">PY</h5>
        <h5 className="column_align_right">{showIndustryMean ? INDUSTRY_MEAN_LABEL : ''}</h5>
        <h5 className="column_align_right">CY</h5>
        <h5 className="column_align_right">PY</h5>
        <h5 className="column_align_right">CY</h5>
        <h5 className="column_align_right">PY</h5>
      </div>
    </>
  );
}
